import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';

type Elevation = 'none' | 'sm' | 'md' | 'lg';

type CardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  elevation?: Elevation;
  /** Drop the default 20px padding (e.g. when nesting list rows). */
  flush?: boolean;
};

const elevationClass: Record<Elevation, string> = {
  none: 'shadow-none',
  sm: 'shadow-sm',
  md: 'shadow-md',
  lg: 'shadow-lg',
};

export function Card({
  children,
  elevation = 'md',
  flush = false,
  className,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn(
        'bg-surface rounded-card',
        elevationClass[elevation],
        !flush && 'p-card-pad',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
